import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function ViewButton({
  fields = [],
  data = {},
  buttonLabel = "View",
  redirectTo = null, // if present → redirect instead of modal
}) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    // If redirectTo is provided → navigate to page
    if (redirectTo) {
      navigate(
        typeof redirectTo === "function" ? redirectTo(data) : redirectTo
      );
    } else {
      // Otherwise open modal
      setOpen(true);
    }
  };

  return (
    <>
      {/* BUTTON */}
      <button
        onClick={handleClick}
        style={{
          padding: "6px 14px",
          background: "#6b7280",
          color: "white",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer",
          fontSize: "14px",
        }}
      >
        {buttonLabel}
      </button>

      {/* MODAL (only if redirectTo IS NOT provided) */}
      {!redirectTo && open && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
            <h2 style={styles.title}>View Details</h2>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gap: "16px",
              }}
            >
              {fields.map((field, index) => {
                let value = data[field.key];

                // CHECK: If custom render provided
                if (field.render) {
                  value = field.render(data);
                }

                return (
                  <div key={index}>
                    <label style={styles.label}>
                      {field.label || field.header}
                    </label>
                    <div style={styles.valueBox}>
                      {value ?? <span style={{ color: "#9ca3af" }}>—</span>}
                    </div>
                  </div>
                );
              })}
            </div>

            <div style={styles.actions}>
              <button onClick={() => setOpen(false)} style={styles.close}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

/* ================================
   STYLES (REQUIRED)
================================ */
const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.45)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  modal: {
    width: "450px",
    background: "white",
    padding: "24px",
    borderRadius: "12px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
  },
  title: {
    marginBottom: "20px",
    fontSize: "20px",
    fontWeight: "600",
  },
  label: {
    fontSize: "13px",
    fontWeight: "500",
    color: "#4b5563",
    marginBottom: "4px",
    display: "block",
  },
  valueBox: {
    padding: "10px",
    border: "1px solid #e5e7eb",
    borderRadius: "6px",
    background: "#f9fafb",
    fontSize: "14px",
    color: "#111827",
  },
  actions: {
    marginTop: "20px",
    display: "flex",
    justifyContent: "flex-end",
  },
  close: {
    padding: "8px 14px",
    background: "#6b7280",
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
  },
};
